module.exports = __webpack_public_path__ + "static/media/logo-hanh@2x.b86f628a.png";